import { render, staticRenderFns } from "./TrainingSessionSort.vue?vue&type=template&id=cf6367ae&"
import script from "./TrainingSessionSort.vue?vue&type=script&lang=ts&"
export * from "./TrainingSessionSort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports